import React from "react";
// Components
import LoginForm from "../../components/login";

const SignIn = () => <LoginForm />;

export default SignIn;
